import React from "react";
import { Link } from "react-router-dom";
import PaginatedDataGrid from "components/PaginatedDataGrid";
import ticketReservationsService from "services/ticketReservations";
import BasicLayout from "components/Layouts/BasicLayout";
import { format } from "date-fns";
import { FilterOption } from "components/PaginatedDataGrid/PaginationFilter";
import eventsService from "services/events";
import { GridColDef } from "@mui/x-data-grid";

const TicketReservations: React.FC = () => {
  const columns: GridColDef[] = [
    {
      field: "eventId",
      headerName: "Event",
      flex: 1,
      minWidth: 200,
      valueGetter: (params) => params.row.event?.title || params.row.eventId
    },
    {
      field: "userId",
      headerName: "User",
      flex: 1,
      valueGetter: (params) => params.row.user?.email || params.row.userId
    },
    {
      field: "status",
      headerName: "Status",
      flex: 1,
      renderCell: (params) => (
        <span className={`px-2 py-1 rounded text-white ${params.value === 'active' ? 'bg-green-500' :
          params.value === 'completed' ? 'bg-blue-500' :
            'bg-red-500'
          }`}>
          {params.value.charAt(0).toUpperCase() + params.value.slice(1)}
        </span>
      )
    },
    {
      field: "expiresAt",
      headerName: "Expires At",
      flex: 1,
      valueGetter: (params) =>
        params.value ? format(new Date(params.value), 'MMM dd, yyyy h:mm a') : 'N/A'
    },
    {
      field: "createdAt",
      headerName: "Created",
      flex: 1,
      valueGetter: (params) =>
        params.value ? format(new Date(params.value), 'MMM dd, yyyy h:mm a') : 'N/A'
    }
  ];

  const filterOptions: FilterOption[] = [
    {
      name: "event._id",
      label: "Event",
      type: "autocomplete",
      service: eventsService,
      fieldName: "title",
      columnWidthMap: { xs: 12, sm: 12, md: 6, lg: 8 },
    },
    {
      name: "status",
      label: "Status",
      type: "select",
      options: [
        { label: "Active", value: "active" },
        { label: "Completed", value: "completed" },
        { label: "Expired", value: "expired" }
      ],
      columnWidthMap: { xs: 12, sm: 12, md: 6, lg: 4 },
    }
  ];

  return (
    <BasicLayout>
      <div className="grid grid-cols-1 md:grid-cols-12 gap-4">
        <div className="md:col-span-9 flex flex-col gap-1">
          <h1 className="text-2xl font-medium">Ticket Reservations</h1>
          <p className="text-sm text-gray-600">
            Ticket reservations are created when a user reserves a ticket for an event on the website.
            They are used to track the status of the reservation and the tickets that are reserved.
          </p>
        </div>
        <div className="md:col-span-3 flex justify-start md:justify-end items-center">
          {/* <Link to="/ticket-reservations/create" className="inline-flex items-center px-2 py-1 text-md bg-blue-600 text-white rounded hover:bg-blue-700 transition-colors">
            <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 mr-1" viewBox="0 0 20 20" fill="currentColor">
              <path fillRule="evenodd" d="M10 5a1 1 0 011 1v3h3a1 1 0 110 2h-3v3a1 1 0 11-2 0v-3H6a1 1 0 110-2h3V6a1 1 0 011-1z" clipRule="evenodd" />
            </svg>
            Create Reservation
          </Link> */}
        </div>
        <div className="col-span-1 md:col-span-12">
          <div className="w-full">
            <PaginatedDataGrid
              collectionName="ticket-reservations"
              defaultSortField="createdAt"
              defaultSortDirection="desc"
              columns={columns}
              service={ticketReservationsService}
              filterOptions={filterOptions}
            />
          </div>
        </div>
      </div>
    </BasicLayout>
  );
};

export default TicketReservations; 